import React from "react";
import ReactDOM from "react-dom";
import App from "./home/App";
import * as serviceWorker from "./serviceWorker";
import DeviceOrientation, { Orientation } from "react-screen-orientation";
import ReactNotification from "react-notifications-component";
import "./stylesheets/index.css";
import "./stylesheets/indexSmallScreen.css";
import "react-notifications-component/dist/theme.css";
import "./stylesheets/notificationThemeSmallScreen.css";

ReactDOM.render(
  <React.StrictMode>
    <ReactNotification />
    {window.innerWidth <= 600 || window.innerHeight <= 600 ? (
      <DeviceOrientation lockOrientation="portrait">
        <Orientation orientation="portrait" alwaysRender={false}>
          <App />
        </Orientation>
        <Orientation orientation="landscape" alwaysRender={false}>
          <div className="rotate">
            <p className="rotate-text">
              Not available in landscape mode,
              <br />
              please rotate your device
            </p>
          </div>
        </Orientation>
      </DeviceOrientation>
    ) : (
      <App />
    )}
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
